import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { SALES_COSTS } from "../../analytics/analytics.config";
import { CommissionService } from "../../../../auth/service/commission.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import { ICommissionAnalyticsSingle, ICommissionAnalyticsSummary, ICommissionList } from "app/auth/models/commission-interface";
import { locale as italian } from "../../../../i18n/it";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { AuthenticationService } from "../../../../auth/service";

@Component({
  selector: "app-commesse",
  templateUrl: "./commission-stats.component.html",
  styleUrls: ["./commission-stats.component.scss"]
})
export class CommissionStats implements OnInit {
  @ViewChild("table") table: any;
  public contentHeader: IContentHeader;
  commissions: ICommissionAnalyticsSummary[];
  commissionsFiltered: ICommissionAnalyticsSingle[];
  allStats: ICommissionAnalyticsSingle[];
  selectCommissions: ICommissionList[];
  customers: any;
  commissionIdSelected: number = 0;
  clientIdSelected: number = 0;
  status: number = 0;
  currentMonth: number = moment().month() + 1;
  currentYear: number = moment().year();
  showChart = false;
  dataChartColumns: any;
  chartOptions: any = SALES_COSTS;
  sumOfEstimatedCosts: number;
  sumOfRealCost: number;
  sumOfEstimateProfit: number;
  sumOfRealProfit: number;
  sumOfMarginCurrency: number;
  averageMarginPercentage: number;
  dataChart: any;
  commissionNameOrEmployeeName: string = "";
  childrenElementNumber: number = 1;
  selectedStartMonth: number = 1;
  selectedStartYear: number = moment().year();
  selectedEndMonth: number = moment().month() + 1;
  selectedEndYear: number = moment().year();
  availableYears: string[] = [];
  availableMonths: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

  constructor(
    private _commissionService: CommissionService,
    public _utilService: UtilsService,
    private _authenticationService: AuthenticationService,
    private _customerService: CustomerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const client = params.client;
      const status = params.status;
      const commission = params.commission;
      const startMonth = params.startMonth;
      const startYear = params.startYear;
      const endMonth = params.endMonth;
      const endYear = params.endYear;

      if (!!searchKey && searchKey != 0) {
        this.commissionNameOrEmployeeName = searchKey;
      }
      if (!!client && Number(client) > 0) {
        this.clientIdSelected = Number(client);
      }
      if (!!status && Number(status) > -1) {
        this.status = Number(status);
      }
      if (!!commission && Number(commission) > 0) {
        this.commissionIdSelected = Number(commission);
      }
      if (!!startMonth && Number(startMonth) > 0) {
        this.selectedStartMonth = Number(startMonth);
      }
      if (!!startYear && Number(startYear) > 0) {
        this.selectedStartYear = Number(startYear);
      }
      if (!!endMonth && Number(endMonth) > 0) {
        this.selectedEndMonth = Number(endMonth);
      }
      if (!!endYear && Number(endYear) > 0) {
        this.selectedEndYear = Number(endYear);
      }
    });

    this.contentHeader = {
      headerTitle: italian.data.MENU.COMMISSIONS_STATS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: italian.data.MENU.ECONOMICS_DATA,
            isLink: false
          },
          {
            name: italian.data.MENU.COMMISSIONS_STATS,
            isLink: false
          }
        ]
      }
    };
    const currentYear: string = moment().format("YYYY");
    if (currentYear) {
      for (let i: number = 2023; i <= Number(currentYear); i++) {
        this.availableYears.push(String(i));
      }
    }
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_stats_commissions")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.customers = await this._customerService.getCustomers();
    this.selectCommissions = await this._commissionService.getCommissions();
    await this.loadStat();
  }

  async loadStat() {
    this._utilService.showLoading();
    const lastDayEndMonth: string = moment(`${this.selectedEndYear}-${String(this.selectedEndMonth).padStart(2, "0")}-01`)
      .endOf("month")
      .format("DD");
    const start: string = `${this.selectedStartYear}-${String(this.selectedStartMonth).padStart(2, "0")}-01`;
    const end: string = `${this.selectedEndYear}-${String(this.selectedEndMonth).padStart(2, "0")}-${lastDayEndMonth}`;

    //Check date
    if (moment(start) > moment(end)) {
      this._utilService.hideLoading();
      this._utilService.showSWALError({ text: "ERROR_DATE_INSERT" });
      this.selectedStartMonth = 1;
      this.selectedEndMonth = moment().month() + 1;
      this.selectedStartYear = moment().year();
      this.selectedEndYear = moment().year();
      this._changeDetectorRef.detectChanges();
      return false;
    }
    this.allStats = await this._commissionService.getAnalyticsCommissions(start, end)
      .then((stats: any[]) => {
        return stats.map((stat: any) => {
          stat.real_cost = Number(stat.real_cost);
          stat.real_profit = Number(stat.real_profit);

          if (stat.real_cost > 0) {
            stat.margin_currency = stat.real_profit - stat.real_cost;
            stat.margin_percentage = this._utilService.calculatePercentageBetweenTwoNumbers(stat.real_profit, stat.real_cost);
          }

          return stat;
        });
      });

    await this.filter();
  }

  async filter(): Promise<void> {
    const resp = this.allStats;
    this.clientIdSelected = this.clientIdSelected===null ? 0 : this.clientIdSelected

    const commissionFilter = (commission) => {
      const commissionNameFilter = commission.commission_complete_name.toLowerCase().includes(this.commissionNameOrEmployeeName.toLowerCase());
      const employeeNameFilter = commission.user.complete_name.toLowerCase().includes(this.commissionNameOrEmployeeName.toLowerCase());

      if (this.commissionIdSelected == 0 && this.clientIdSelected == 0) {
        return commission.status == this.status && (commissionNameFilter || employeeNameFilter);
      } else {
        if (this.commissionIdSelected > 0) {
          return commission.commission_id == this.commissionIdSelected && commission.status == this.status && (commissionNameFilter || employeeNameFilter);
        } else {
          return commission.client_id == this.clientIdSelected && commission.status == this.status && (commissionNameFilter || employeeNameFilter);
        }
      }
    };

    this.commissionsFiltered = resp.filter(commissionFilter);
    this.dataChartColumns = resp.filter(commissionFilter);

    this.setGroupedCommissions();
    this.calculateTotal();
    await this.initChart();
    this.changeQueryParams();
    this._utilService.hideLoading();
  }

  setGroupedCommissions(): void {
    const groupedCommissions: any[] = [];

    this.commissionsFiltered.forEach((commission) => {
      let commissionSummary: ICommissionAnalyticsSummary = groupedCommissions.find((group) => group.commission_id === commission.commission_id);
      if (!commissionSummary) {
        commissionSummary = {
          commission_id: commission.commission_id,
          commission_complete_name: commission.commission_complete_name,
          commission_details: [],
          total_estimate_cost: 0,
          total_estimate_profit: 0,
          total_margin_currency: 0,
          total_real_cost: 0,
          total_real_profit: 0,
          status: 0,
          margin_euro: 0,
          margin_percentage: 0
        };
        groupedCommissions.push(commissionSummary);
      }

      commissionSummary.commission_details.push({
        commission_complete_name: commission.commission_complete_name,
        month: commission.month,
        year: commission.year,
        order_id: commission.order_id,
        real_cost: parseFloat(commission.real_cost),
        real_profit: parseFloat(commission.real_profit),
        estimate_cost: parseFloat(commission.estimate_cost),
        estimate_profit: parseFloat(commission.estimate_profit),
        margin_percentage: parseFloat(commission.margin_percentage),
        margin_currency: parseFloat(commission.margin_currency),
        status: commission.status,
        user: commission.user
      });

      commissionSummary.total_estimate_cost += parseFloat(commission.estimate_cost);
      commissionSummary.total_estimate_profit += parseFloat(commission.estimate_profit);
      commissionSummary.total_margin_currency += parseFloat(commission.margin_currency);
      commissionSummary.total_real_cost += parseFloat(commission.real_cost);
      commissionSummary.total_real_profit += parseFloat(commission.real_profit);
    });

    groupedCommissions.forEach((group) => {
      for (let detail of group.commission_details) {
        detail.year_month_cost = detail.year + detail.month.toString().padStart(2, "0") + detail.estimate_cost.toString();
      }

      group.commission_details.sort((a, b) => a.year_month_cost > b.year_month_cost ? 1 : a.year_month_cost < b.year_month_cost ? -1 : 0);

      if (group.total_real_cost) {
        group.margin_euro = Number((group.total_real_profit - group.total_real_cost).toFixed(2));
        group.margin_percentage = this._utilService.calculatePercentageBetweenTwoNumbers(group.total_real_profit, group.total_real_cost);

        if(group.margin_percentage === 0 && group.total_real_profit < 1){
          group.margin_percentage = -100;
        }
      }
    });

    this.commissions = groupedCommissions;
  }

  async initChart() {
    const currentMonth = new Date().getMonth();
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const orderedMonths = [
      ...monthNames.slice(currentMonth + 1), // Months from the current month to December
      ...monthNames.slice(0, currentMonth + 1) // Months from January to the current month
    ];
    const translatedMonths = await Promise.all(orderedMonths.map((month) => this.translate("COMMISSIONS." + month.toUpperCase())));

    const monthlyTotals = {};
    orderedMonths.forEach((month) => {
      monthlyTotals[month] = {
        estimate_cost: 0,
        estimate_profit: 0,
        real_cost: 0,
        real_profit: 0
      };
    });

    this.dataChartColumns.forEach((item) => {
      const month = monthNames[item.month - 1];
      monthlyTotals[month].estimate_cost += parseFloat(item.estimate_cost) || 0;
      monthlyTotals[month].estimate_profit += parseFloat(item.estimate_profit) || 0;
      monthlyTotals[month].real_cost += parseFloat(item.real_cost) || 0;
      monthlyTotals[month].real_profit += parseFloat(item.real_profit) || 0;
    });

    const estimateCostData = Object.values(monthlyTotals).map((total: any) => total.estimate_cost);
    const estimateProfitData = Object.values(monthlyTotals).map((total: any) => total.estimate_profit);
    const realCostData = Object.values(monthlyTotals).map((total: any) => total.real_cost);
    const realProfitData = Object.values(monthlyTotals).map((total: any) => total.real_profit);

    this.dataChart = {
      series: [
        { name: await this.translate("ESTIMATED_COST"), type: "column", data: estimateCostData },
        { name: await this.translate("EFFECTIVE_COST"), type: "column", data: realCostData },
        { name: await this.translate("ESTIMATED_REVENUE"), type: "column", data: estimateProfitData },
        { name: await this.translate("EFFECTIVE_REVENUE"), type: "column", data: realProfitData }
      ],
      xaxis: { categories: translatedMonths }
    };
  }

  translate(label: string) {
    return this._utilService.translate(label);
  }

  toggleChart() {
    this.showChart = !this.showChart;
  }

  toggleExpandRow(row, expanded) {
    if (!expanded) {
      this.table.rowDetail.collapseAllRows();
    }
    if (row.children && row.children.length > 0) {
      this.childrenElementNumber = row.children.length;
    }

    this.table.rowDetail.toggleExpandRow(row);
  }

  formatDate(date: Date): string {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
  }

  calculateTotal(): void {
    const sumProperty = (property) => this.commissionsFiltered.reduce((total, commission) => total + parseFloat(commission[property]), 0);
    this.sumOfEstimatedCosts = sumProperty("estimate_cost");
    this.sumOfRealCost = sumProperty("real_cost");
    this.sumOfEstimateProfit = sumProperty("estimate_profit");
    this.sumOfRealProfit = sumProperty("real_profit");
    this.sumOfMarginCurrency = sumProperty("margin_currency");

    const marginPercentages = this.commissionsFiltered.map((commission) => parseFloat(commission.margin_percentage));
    this.averageMarginPercentage = this.calculateAverage(marginPercentages);
  }

  calculateAverage(values: number[]): number {
    if (values.length === 0) {
      return 0;
    }
    const sum = values.reduce((total, value) => total + value, 0);
    return sum / values.length;
  }

  async export() {
    let fullData: any = this.commissions;
    if (!!fullData && fullData.length > 0) {
      return this._utilService.exportAsExcelFile(
        fullData.map((commission: any) => {
          return {
            "Nome commessa": commission.commission_complete_name,
            "Costo presunto": this._utilService.addDotsToNumber(commission.total_estimate_cost) + " €",
            "Costo effettivo": this._utilService.addDotsToNumber(commission.total_real_cost) + " €",
            "Fatturato presunto": this._utilService.addDotsToNumber(commission.total_estimate_profit) + " €",
            "Fatturato effettivo": this._utilService.addDotsToNumber(commission.total_real_profit) + " €",
            "Margine €": this._utilService.addDotsToNumber(commission.total_margin_currency) + " €",
            "Margine %": commission.average_margin_percentage + " %"
          };
        }),
        "export-commissions"
      );
    }
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.commissionNameOrEmployeeName && this.commissionNameOrEmployeeName.length >= 3) {
      url.searchParams.set("search", String(this.commissionNameOrEmployeeName));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.clientIdSelected && Number(this.clientIdSelected) > 0) {
      url.searchParams.set("client", String(this.clientIdSelected));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("client");
      history.pushState({}, "", url);
    }

    if (!!this.status && this.status > -1) {
      url.searchParams.set("status", String(this.status));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status");
      history.pushState({}, "", url);
    }
    if (!!this.commissionIdSelected && this.commissionIdSelected > 0) {
      url.searchParams.set("commission", String(this.commissionIdSelected));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("commission");
      history.pushState({}, "", url);
    }

    if (this.selectedStartMonth != 1) {
      url.searchParams.set("startMonth", String(this.selectedStartMonth));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("startMonth");
      history.pushState({}, "", url);
    }
    if (this.selectedStartYear !== moment().year()) {
      url.searchParams.set("startYear", String(this.selectedStartYear));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("startYear");
      history.pushState({}, "", url);
    }

    if (this.selectedEndMonth !== moment().month() + 1) {
      url.searchParams.set("endMonth", String(this.selectedEndMonth));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("endMonth");
      history.pushState({}, "", url);
    }
    if (this.selectedEndYear !== moment().year()) {
      url.searchParams.set("endYear", String(this.selectedEndYear));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("endYear");
      history.pushState({}, "", url);
    }
  }

  formatMonth(month: any, format: string = "MMMM") {
    const date: moment.Moment = moment();
    date.set("month", month - 1);
    return date.format(format);
  }

  reset() {
    this.commissionIdSelected = 0;
    this.clientIdSelected = 0;
    this.commissionNameOrEmployeeName = "";
    this.status = 0;
    this.selectedStartMonth = 1;
    this.selectedEndMonth = moment().month() + 1;
    this.selectedStartYear = moment().year();
    this.selectedEndYear = moment().year();
    this.loadStat();
    this.changeQueryParams();
  }
}
